import React, { useRef,useEffect,useState } from "react";
import "../Modals.css";
import "../ModalMenuMobile.css"
import { Nav } from "react-bootstrap";
import ButtonNavLinkMobile from '../../../Atoms/Buttons/ButtonNavLinkMobile/ButtonNavLinkMobile';
import { closeSession } from "../../../../Core/Features/FeatureGlobal";
import ReactDOM from 'react-dom'
export default function ModalMenuMobile({onOutsideClick,type}){
  
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
          if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            onOutsideClick();
          }
        };
    
        document.addEventListener('mousedown', handleClickOutside);
    
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, [onOutsideClick]);


  return (
        <>
        <div className="portal encuesta" >
        <div ref={wrapperRef} className="mobile-menu-container" >
        <Nav.Link className='navlink__mobile'  href="/homein">
        <ButtonNavLinkMobile
                        classname__link__mobile={'ButtonNavLinkMobile iconNavlinkHome'}
                        text__navlink__mobile={type == 1 ? 'Asalariado' : 'Independiente'}
        />
        </Nav.Link>
        <Nav.Link className='navlink__mobile'  href="/mi-perfil">
                      <ButtonNavLinkMobile
                        classname__link__mobile={'ButtonNavLinkMobile iconNavlinkProfile'}
                        text__navlink__mobile={'Mi perfil'}
                      />
        </Nav.Link>
        <Nav.Link className='navlink__mobile'  href="/centro-de-ayuda">
                      <ButtonNavLinkMobile
                        classname__link__mobile={'ButtonNavLinkMobile iconNavlinkHelp'}
                        text__navlink__mobile={'Ayuda'}
                      />
        </Nav.Link>
        <Nav.Link className='navlink__mobile'  onClick={() => { closeSession() }}>
                      <ButtonNavLinkMobile
                        classname__link__mobile={'ButtonNavLinkMobile iconNavlinkLogout'}
                        text__navlink__mobile={'Cerrar sesión'}
                      />
        </Nav.Link>
        </div>
        </div>
        
        </>
       

  );
}